import { useContext } from 'react';

import { Container, NextLink } from '@/atoms';

import { InitPropsProvider } from '@/components/providers';
import { routes } from '@/lib/routes';

export const FooterSimple = () => {
  const propsProvider = useContext(InitPropsProvider);
  const menus = propsProvider.menus;
  const legal = menus?.legal;
  const bcOptions = propsProvider?.options ?? {};
  const copyright = bcOptions?.copyright;

  return (
    <footer aria-labelledby="footer-heading">
      <p id="footer-heading" className="sr-only">
        footer
      </p>

      <Container
        wrapper
        padding="px-4 py-4"
        backgroundColor="bg-bg-tertiary"
        className="text-typo-alternative"
      >
        <div className="u-actions u-actions--link flex flex-col justify-center gap-10 text-center lg:flex-row lg:justify-between lg:text-left">
          <ul
            role="list"
            className="flex flex-col flex-wrap gap-4 lg:flex-row lg:gap-x-12 lg:gap-y-4"
          >
            {legal?.items?.map((item, index) => (
              <li key={index}>
                <NextLink href={item.url}>
                  <a>{item.label}</a>
                </NextLink>
              </li>
            ))}
            <li>
              <NextLink href={routes.contact}>
                <a>Contacto</a>
              </NextLink>
            </li>
          </ul>

          <p className="shrink-0">{copyright}</p>
        </div>
      </Container>
      <Container
        wrapper
        padding="px-4 py-4"
        backgroundColor="bg-bg-tertiary"
        className="border-t border-primary-600 text-typo-alternative"
      >
        <div className="u-body u-body--s flex flex-col justify-center gap-10 text-center text-primary-400 lg:flex-row lg:justify-between lg:text-left">
          Estrella Galicia recomienda el consumo responsable. Prohibida la venta
          o suministro de bebidas alcohólicas a menores de 18 años.
        </div>
      </Container>
    </footer>
  );
};
